import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unauthenticated',
  templateUrl: './unauthenticated.html',
  styleUrl: './unauthenticated.scss',
  imports: [
    NgOptimizedImage,
    TranslocoPipe
  ]
})
export class Unauthenticated {
  protected readonly hubUrl = environment.jcbPortal;
}
